export default (props, vars) =>
  props?.['loading'] || props?.['disabled'] ? () => {} : props?.['onClick'];
